import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { LoginView } from './LoginView';
import './index.css';

/**
 * Routing.
 *
 * One extra route does not justify pulling in a router: the whole decision is
 * which of two components to mount. Navigation between them is a full page
 * load (an <a href> or location.assign), which also guarantees the session
 * lookup re-runs — exactly what is wanted after signing in or out.
 *
 * nginx already maps any unknown path to index.html (try_files ... /index.html)
 * and Vite's dev server does the same, so /login resolves here on a direct hit
 * or a refresh, not just via in-app navigation.
 */
function Root() {
  // Trailing slashes are tolerated so /login/ behaves like /login.
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/login') return <LoginView />;
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
